import "../assets/css/Hero.css";

export default function Hero() {
  return (
    <div className="hero">
      <p>S A L E ! ! !</p>
    </div>
  );
}
